import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class CaseModel extends BaseModel {
  static urlPath = "case";

  @attr("boolean") accidentPicturesReceived;
  @attr("number") actualTotalSettlementNumber;
  @attr("boolean") allMedicalDocsReceived;
  @attr("boolean") allTreatmentsComplete;
  @attr("number") appointmentsCt;
  @attr("boolean") archived;
  @belongsTo("assignee") assignee;
  @attr("string") callbackReason;
  @attr("string") callbackTime;
  @attr("number") campaign;
  @belongsTo("client") client;
  @attr("number") clientSettlementAmount;
  @attr("boolean") crashReportReceived;
  @attr("datetime") createdAt;
  @attr("date") dateOfAccident;
  @belongsTo("entity") entity;
  @attr("boolean") hasCheck;
  @attr("string") incidentCity;
  @attr("number") incidentLocation;
  @attr("string") incidentRole;
  @attr("string") incidentType;
  @attr("datetime") incidentSettlementDate;
  @attr("boolean") introducedToNp;
  @attr("datetime") lastContacted;
  @attr("number") lawFirm;
  @attr("string") lawFirmName;

  @attr("string") legalStatus;
  @attr("string") actualTotalSettlementAmount;
  @attr("string") medPayAmount;
  @attr("number") medicalLimits;
  @attr("string") overallStatus;
  @attr("string") status;
  @attr("string") currentBalanceTotal;
  @attr("string") runningTotal;

  @attr("array") medicalStatusCounts;

  @attr("string") name;
  @attr("string") comboName;
  @attr("datetime") updatedAt;
  @attr("number") pk;
}
